import * as web3 from '@solana/web3.js';

export const SYSTEM_PROGRAM_ID = new web3.PublicKey('11111111111111111111111111111111');

export const TOKEN_PROGRAM_ID = new web3.PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');

export const MEMO_PROGRAM_ID = new web3.PublicKey('Memo1UhkJRfHyvLMcVucJwxXeuD728EqVDDwQDxFMNo');

export const WRAPPED_SOL_MINT = new web3.PublicKey('So11111111111111111111111111111111111111112');
